// extracted by mini-css-extract-plugin
module.exports = {"Right":"MainPage_Right__1F35G","Header":"MainPage_Header__1TTqW"};